import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";
import { auraGames } from "../../lib/data/auraGames.data";
import { slotsGames } from "../../lib/data/slotsGames.data";
import { PragmaticPlayGames } from "../../lib/data/pragmaticplay.data";
import { SlotGames } from "../../lib/data/SlotGames.data";
import { casinoPageData } from "../../lib/data";
import { useLocation } from "react-router-dom";

const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const location = useLocation(); 
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState(false);
  const [totalGames, setTotalGames] = useState([]);

  const baseGames = useMemo(() => {
    const games = [];
    for (const providerKey in casinoPageData) {
      const provider = casinoPageData[providerKey];
      for (const categoryKey in provider) {
        const category = provider[categoryKey];
        games.push(...Object.values(category));
      }
    }
    return games;
  }, [casinoPageData]);


  useEffect(() => {
    let pageGames = [];

    if (location.pathname.includes("pragmaticplay")) {
      pageGames = Object.values(PragmaticPlayGames.PragmaticPlayGames.slide1);
    } else if (location.pathname.includes("aura-games")) {
      pageGames = Object.values(auraGames);
    } else if (location.pathname.includes("casinogames")) {
      pageGames = Object.values(SlotGames.ezugiSlotsGames , SlotGames.jiliGames , SlotGames.netenttab , SlotGames.redtigertab);
    } else {
      pageGames = Object.values(slotsGames);
    }

    // Combine both sets without mutating
    setTotalGames([...baseGames, ...pageGames]);
  }, [location, baseGames]);


  const handleSearch = (e) => {
    if (e) {
      setSearchText(true);

      let filteredValue = Object.values(totalGames)?.filter((item) => {
        if (typeof item !== "string") {
          return item?.name?.toLowerCase()?.indexOf(e?.toLowerCase()) > -1;
        }
        return false;
      });
      setFilteredData(filteredValue);
    } else {
      setSearchText(false);
      setFilteredData(null);
    }
  };

  return (
    <>
      <div className="searchGames" onClick={handleShow}>
        <BiSearch />
        <p>Search games</p>
      </div>

      <Modal show={show} onHide={handleClose} className="gameSearchModal">
        <Modal.Header closeButton>
          <Modal.Title>Search your favourite games</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3 search-icon">
            <Form.Control
              placeholder="Search"
              aria-label="Text input with dropdown button"
              type="search"
              onChange={(e) => handleSearch(e.target.value)}
              autoFocus
            />
          </InputGroup>
          <div className="game-list">
            {filteredData &&
              filteredData.map((item) => (
                <a href={item.redirectUrl || item?.href}>
                  {item.imgUrl ? <img src={item.imgUrl} /> : item.img}
                  <span>{item.name}</span>
                </a>
              ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GamesSearchModal;
